import React from 'react';
import { useNavigate } from 'react-router-dom';
import GlassCard from '../ui/GlassCard';
import ActivityTierBadge from '../ui/ActivityTierBadge';
import './StandardCelebrityCard.css';

const StandardCelebrityCard = ({ celebrity }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/celebrity/${celebrity.investor_pb_id}`);
  };

  const formatCurrency = (amount) => {
    if (amount >= 1000000000) return `$${(amount / 1000000000).toFixed(1)}B`;
    if (amount >= 1000000) return `$${(amount / 1000000).toFixed(0)}M`;
    if (amount >= 1000) return `$${(amount / 1000).toFixed(0)}K`;
    return `$${amount}`;
  };

  return (
    <GlassCard className="standard-celebrity-card" onClick={handleClick}>
      <div className="card-content">
        <div className="avatar-small">
          {celebrity.investor_name.split(' ').map(n => n[0]).join('')}
        </div>
        
        <h4 className="celebrity-name">{celebrity.investor_name}</h4>
        <p className="celebrity-role">{celebrity.display_role}</p>
        
        <ActivityTierBadge 
          tier={celebrity.activity_tier} 
          size="sm" 
        />
        
        <div className="stats">
          <div className="stat">
            <span className="stat-value">{celebrity.total_investments}</span>
            <span className="stat-label">Investments</span>
          </div>
          <div className="stat-divider"></div>
          <div className="stat">
            <span className="stat-value">{celebrity.total_exits}</span>
            <span className="stat-label">Exits</span>
          </div>
        </div>
        
        <div className="investment-values">
          <div className="investment-value">
            <span className="value-label">Active Portfolio</span>
            <span className="value-amount">{formatCurrency(celebrity.total_invested_active)}</span>
          </div>
          <div className="investment-value">
            <span className="value-label">Previous/Exits</span>
            <span className="value-amount">{formatCurrency(celebrity.total_invested_previous)}</span>
          </div>
        </div>
        
        <div className="latest-investment">
          <span className="latest-label">Last Investment:</span>
          <span className="latest-company">{celebrity.latest_company}</span>
          <span className="latest-time">- {celebrity.latest_investment_timeago}</span>
        </div>
        
        <div className="preferred-industries">
          <span className="industries-label">Preferred Industries:</span>
          <div className="industries-list">
            {celebrity.preferred_industries?.slice(0, 3).map((industry, idx) => (
              <span key={idx} className="industry-chip">{industry}</span>
            ))}
          </div>
        </div>
      </div>
    </GlassCard>
  );
};

export default StandardCelebrityCard;